import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, GuardResult, MaybeAsync, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})
export class CanDeactivateGuard implements CanDeactivate<CanDeactivateComponent> {
    constructor() {}

    canDeactivate(
        component: CanDeactivateComponent,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ): MaybeAsync<GuardResult> {
        if (typeof component.canDeactivate === 'function') {
            return component.canDeactivate();
        }
        return true;
    }
}

export interface CanDeactivateComponent {
    canDeactivate(): MaybeAsync<GuardResult>;
}
